import { render, staticRenderFns } from "./addCourse.vue?vue&type=template&id=f2d64b2e&scoped=true&"
import script from "./addCourse.vue?vue&type=script&lang=js&"
export * from "./addCourse.vue?vue&type=script&lang=js&"
import style0 from "./addCourse.vue?vue&type=style&index=0&id=f2d64b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d64b2e",
  null
  
)

component.options.__file = "addCourse.vue"
export default component.exports